import * as React from 'react';
import ServicesContext from '../../contexts/servicesContext';

interface ITopicPilotFormProps {
    vin: string;
    uiLanguage: string;
    partNumber: string;
    bid: string;
}

interface ITopicPilotFormState {}

class TopicPilotForm extends React.Component<ITopicPilotFormProps, ITopicPilotFormState> {
    static contextType = ServicesContext;
    context: React.ContextType<typeof ServicesContext>;

    formRef: any;

    constructor(props: any) {
        super(props);
        this.formRef = React.createRef();
    }

    handleFormSubmit = () => {
        if (this.props.uiLanguage && this.props.partNumber && this.props.bid) {
            this.formRef.current.submit();
        }
    }

    componentDidUpdate() {
        this.handleFormSubmit();
    }

    shouldComponentUpdate(nextProps: ITopicPilotFormProps, nextState: ITopicPilotFormState) {
        if (this.props.partNumber == nextProps.partNumber && this.props.uiLanguage == nextProps.uiLanguage && this.props.bid == nextProps.bid) {
            return false;
		}

        return true;
	}

    render(): any {
        return <React.Fragment>
            <form style={{ display: 'none' }} ref={this.formRef} method="post" id="topic-pilot-form" action={this.context.settingsService.data.topicPilotDirectUrl} target="_self">
                {this.props.vin ?
                    <input type="hidden" name="vin" value={this.props.vin} />
                    :
                    <input type="hidden" name="partNumber" value={this.props.partNumber} />}
                <input type="hidden" name="uiLanguage" value={this.props.uiLanguage} />
                <input type="hidden" name="importerId" value={this.props.bid} />
            </form>
        </React.Fragment>
    }
}

export default TopicPilotForm;